import React from 'react';

const Call: React.FC = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 17.3477H16.5C17.053 17.3477 17.5 16.9007 17.5 16.3477V12.3477C17.5 11.7947 17.053 11.3477 16.5 11.3477H12.5C11.947 11.3477 11.5 11.7947 11.5 12.3477V13.3477C7.5 13.3477 4.563 10.2857 4.5 6.34766H5.5C6.053 6.34766 6.5 5.90066 6.5 5.34766V1.34766C6.5 0.794656 6.053 0.347656 5.5 0.347656H1.5C0.948 0.347656 0.5 0.794656 0.5 1.34766V6.34766C0.5 12.4227 5.425 17.3477 11.5 17.3477Z"
      fill="black"
    />
  </svg>
);

export default Call;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/TechCoachCTA/icons/Call.tsx